/**
 * Utilitaires de formatage partagés pour les contrats
 */

// Re-export centralized date formatters
export { formatDate, formatDateTime } from '@/utils/dateUtils';

export const formatPrice = (price: number | null | undefined): string => {
  if (price === null || price === undefined) return '-';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
};

export { formatPhone } from '@/utils/formatters';

export const formatFullName = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName.toUpperCase()}`;
};

export const formatAddress = (
  address?: string,
  address2?: string,
  cp?: string,
  city?: string,
): string => {
  const parts: string[] = [];
  if (address) parts.push(address);
  if (address2) parts.push(address2);
  if (cp && city) parts.push(`${cp} ${city}`);
  return parts.join(', ') || '-';
};

export const formatPaymentType = (
  monthlyPaymentId: string | null | undefined,
): string => {
  if (!monthlyPaymentId) return 'Comptant';

  if (monthlyPaymentId.startsWith('sub_') || monthlyPaymentId.startsWith('seti_')) {
    return 'Mensuel';
  }

  if (monthlyPaymentId.startsWith('pi_')) {
    return 'Comptant en ligne';
  }

  return 'Comptant en ligne';
};

export interface ContractPriceInput {
  sellingPrice: number;
  duration: number;
  monthlyPriceClient?: number | null;
}

export type ContractDisplayPrice =
  | { kind: 'cash'; total: number }
  | { kind: 'monthly'; monthly: number; duration: number };

/**
 * Source unique : le backend calcule et fournit monthlyPriceClient selon le mode warranty.
 * - monthlyPriceClient renseigné → mensualité TTC à afficher (jamais divisée)
 * - monthlyPriceClient null → paiement comptant, afficher sellingPrice
 */
export const getContractDisplayPrice = (c: ContractPriceInput): ContractDisplayPrice => {
  if (c.monthlyPriceClient != null) {
    return { kind: 'monthly', monthly: c.monthlyPriceClient, duration: c.duration };
  }
  return { kind: 'cash', total: c.sellingPrice };
};

export const formatDuration = (months: number): string => {
  if ([12, 24, 48, 60].includes(months)) {
    return `${months} mois`;
  }

  if (months < 12) {
    return `${months} mois`;
  }

  const years = months / 12;
  if (years === 1) {
    return '1 an';
  }

  return `${years} ans`;
};
